import { TableConfiguration } from '../../../../../../../baseComponents/TwinTable/types'
import { InputTableURLsTable, OrderHeaderURLs } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { SetTPVCompleteDataTy, TPVOrderData } from '../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import SellTicketCreateStep from './Steps/SellTicketCreateStep'
import { sellTicketStatusInversed } from '@teinor/erp/types/company/order/sell/sellTicket'
import SellTicketFinishedStep from './Steps/SellTicketFinishedStep'
import SellRefundTicketStep from './Steps/SellRefundTicketStep'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { getUserPermissions } from '../../../../../../../utils/reducers/getters'
import SellTicketCreateNoPermissionStep from './Steps/SellTicketCreateNoPermissionStep'
import './productTicketTPV.sass'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { WorkingCenterPayload } from '../../../../../../../utils/reducers/company/workingCenters'
import SellTicketPartialChargedStep from './Steps/SellTicketPartialChargedStep'


export interface ProductTicketTPVDSBProps {
    completeData: TPVOrderData | null
    inputTableURLs: InputTableURLsTable
    orderHeaderURLs: OrderHeaderURLs
    setCompleteData: SetTPVCompleteDataTy
    setTableConfiguration: React.Dispatch<React.SetStateAction<TableConfiguration>>
    tableConfiguration: TableConfiguration
    getCompleteData: () => Promise<void>
    title: string
  
 }

const ProductTicketTPVDSB: React.FC<ProductTicketTPVDSBProps> = ({ completeData, ...rest }) => {
    const { t } = useTwinTranslation()
    if (!completeData) {
        return null
    }
    const translationsTicket = {
        [sellTicketStatusInversed['refunded']]: t('refundedTicket', 'Ticket devuelto'),
        [sellTicketStatusInversed['canceled']]: t('canceledTicket', 'Ticket  cancelado'),
    }
    const status = parseInt(completeData?.header?.status)
    if (status === sellTicketStatusInversed['accepted'] || status === sellTicketStatusInversed['partialRefunded'] || status === sellTicketStatusInversed['refunded']) {
        const title = translationsTicket[status] || t('yourTicket', 'Tu ticket')
        return <SellTicketFinishedStep {...{ completeData, ...rest, title }} />
    } else if (completeData?.header?.SellTicketId || status === sellTicketStatusInversed['canceled']) {
        const title = translationsTicket[status] || t('refund', 'Devolución')
        return <SellRefundTicketStep {...{ completeData, ...rest, title }} />
    } else if (!permissionCheck(getUserPermissions('sell.tickets'), 'update') || completeData?.header?.hidePrices || completeData?.header?.notModificable) {
        return <SellTicketCreateNoPermissionStep {...{ completeData, ...rest }} />
    } else if (status === sellTicketStatusInversed['partialCharged']) {
        return <SellTicketPartialChargedStep {...{ completeData, ...rest }} />
    }
    return (
        <SellTicketCreateStep {...{ completeData, ...rest }} />
    )
}

const workingCenterDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
}

export type ReduxWorkingCenter = ConnectedProps<typeof WorkingCenterConnect>
const mapWorkingCenterConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters })
const WorkingCenterConnect = connect(mapWorkingCenterConnector, workingCenterDispatch)
const WorkingCenterConnectLoading = withLoading(ProductTicketTPVDSB, [{ fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }])
const ProductTicketTPVDSBConnect = WorkingCenterConnect(WorkingCenterConnectLoading)

export default ProductTicketTPVDSBConnect
